import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { Ionicons } from "@expo/vector-icons";

import { extractHashtags, removeHashtags } from "@/formatting/text";
import { getRandomColor } from "@/utils/colors";

type AboutMeProps = {
  bio: string | null;
};

function AboutMe({ bio }: AboutMeProps): React.JSX.Element {
  if (bio === "" || bio === null) {
    return <></>;
  }

  const cleanBio = removeHashtags(bio);
  const tags = extractHashtags(bio);

  return (
    <View style={styles.container}>
      <View style={styles.sectionContainer}>
        <Ionicons name="text-sharp" size={25} color="#01579b" />
        <Text style={styles.sectionTitle}>{"About Me"}</Text>
      </View>
      <View style={styles.contentContainer}>
        <View style={styles.bioContainer}>
          <Text style={styles.bioText}>{cleanBio}</Text>
        </View>
        <View style={styles.tagsContainer}>
          {tags.map((tag, index) => (
            <View
              key={index}
              style={[styles.tag, { backgroundColor: getRandomColor() }]}
            >
              <Text style={styles.tagText}>#{tag}</Text>
            </View>
          ))}
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 16,
  },
  sectionContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 8,
  },
  sectionTitle: {
    fontSize: 20,
    marginLeft: 5,
    fontWeight: "bold",
  },
  bioContainer: {
    alignItems: "center",
    flexDirection: "row",
    marginBottom: 10,
  },
  bioText: {
    color: "#2D3748",
    flex: 1,
    fontSize: 16,
    marginLeft: 10,
    marginRight: 10,
    textAlign: "left",
  },
  contentContainer: {
    padding: 12,
    backgroundColor: "#f5f5f5",
  },
  tag: {
    borderRadius: 12,
    marginBottom: 8,
    marginRight: 8,
    paddingHorizontal: 8,
    paddingVertical: 4,
  },
  tagText: {
    color: "#FFFFFF",
    fontSize: 12,
    fontWeight: "600",
  },
  tagsContainer: {
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    marginTop: 10,
  },
});

export default AboutMe;
